import React, { useState, useEffect } from "react";
import Popup from "../../../../../../UI/Popup/popup";
import * as apiClient from "../../../../../../common/apiClient";
import * as apiMethod from "../../../../../../common/apiMethod";
import * as appModule from "../../../../../../common/appModule";

const pulsateKeyframes = `
  @keyframes pulsate {
    0% { transform: scale(0.75); }
    50% { transform: scale(1.75); }
    100% { transform: scale(0.75); }
  }
`;

const rotateKeyframes = `
  @keyframes rotate {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const styles = {
  container: {
    margin: "25vh auto 0",
  },
  loader: {
    width: "125px",
    height: "125px",
    margin: "0 auto",
    position: "relative",
  },
  circle: {
    textAlign: "center",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    border: "5px solid lightgray",
    position: "relative",
  },
  innerCircle: {
    position: "relative",
    left: "-12.5%",
    top: "35%",
    width: "125%",
    height: "25%",
    backgroundColor: "white",
    animation: "rotate 2s infinite linear",
  },
  text: {
    position: "relative",
    color: "darkgray",
    top: "-0.25em",
    fontFamily: "Raleway",
    animation: "pulsate 1.25s infinite ease",
    margin: "20px 0px 0px",
  },

  remarkText: {
    // position: 'relative',
    color: "darkgray",
    top: "-0.25em",
    fontFamily: "Raleway",
    //animation: 'pulsate 1s infinite ease',
    margin: "0px 0px 0px",
    textAlign: "center",
  },
};

export const AddPayment = (props) => {
  const [paymentAmount, setPaymentAmount] = useState(1000);
  const [paymentRemarks, setPaymentRemarks] = useState("");
  const [generatePayment, setGeneratePayment] = useState(true);
  const [isPaymentProcessLoading, setIsPaymentProcessLoading] = useState(false);
  const [paymentLink, setPaymentLink] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const key = "WL63FAVT0";
  const access_key =
    "7362021a3bc3410c7761d3c363d032d0d72d32c48de05e08076a255450044ab1";
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const handleOptionClick = (amount) => {
    let currentAmt = paymentAmount;
    if (currentAmt) {
      currentAmt = parseInt(currentAmt) + parseInt(amount);
    } else {
      currentAmt = amount;
    }
    setPaymentAmount(currentAmt);
  };

  const GeneratePaymentLink = async () => {
    debugger;
    let formBody = {
      consignorCode: "",
      payment_amount: paymentAmount,
    };
    setGeneratePayment(true);
    setIsLoading(true);
    setIsPaymentProcessLoading(true);
    setPaymentRemarks("Payment Processing,Please Wait...");
    await apiClient
      .post(
        `${apiClient.baseUrl}${appModule.tmsModule}${apiMethod.tmsMethod.zoho.generatePayment}`,
        formBody
      )
      .then((response) => {
        setGeneratePayment(false);
        setIsPaymentProcessLoading(false);
        setIsLoading(false);
        let link = response.ResultSet.payment_link;
        //alert(link);
        if (response.IsSuccess) {
          debugger;
          const pattern = /^http:\/\/|^https:\/\//;
          if (pattern.test(link) && link.startsWith("https://")) {
            setPaymentLink(link.replace(/^http:\/\//, "https://"));
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setGeneratePayment(false);
        setIsPaymentProcessLoading(false);
        setIsLoading(false);
        setPaymentRemarks(err);
      });
    //  return result;
  };

  return (
    <Popup
      open={props.isOpen}
      title={props.popupTtile}
      onClose={props.handleClosePopup}
      customClasses={
        paymentLink != null
          ? "popup-content-50 custom-height-80_percent wallet-popup-margin-68"
          : "popup-content-30 custom-height-40_percent wallet-popup-margin-68"
      }
    >
      {generatePayment && (
        <div className="add-amount-container">
          <div className="selected-amount">
            <span>&#x20B9;</span>
            <input
              type="number"
              value={paymentAmount}
              onChange={(event) => setPaymentAmount(event.target.value)}
              placeholder="Enter Amount"
            />
          </div>
          <div className="amount-options">
            <button onClick={() => handleOptionClick(500)}>+ 500</button>
            <button onClick={() => handleOptionClick(1000)}>+ 1000</button>
            <button onClick={() => handleOptionClick(2000)}>+ 2000</button>
          </div>
          {paymentAmount && paymentAmount > 0 && (
            <button onClick={GeneratePaymentLink} className="continue-button">
              Proceed To Add
            </button>
          )}
        </div>
      )}
      {isPaymentProcessLoading && (
        <>
          <style>
            {pulsateKeyframes}
            {rotateKeyframes}
          </style>
          <div style={styles.container}>
            <div style={styles.loader}>
              <div style={styles.circle}>
                <div style={styles.innerCircle}></div>
                <h1 style={styles.text}>₹</h1>
              </div>
            </div>
          </div>
          {paymentRemarks != "" && (
            <h1 style={styles.remarkText}>{paymentRemarks}</h1>
          )}
        </>
      )}
      {paymentLink != null && (
        <iframe
          src={paymentLink}
          style={{ outline: "none", border: "none" }}
          height={"90%"}
          width={"100%"}
          title=""
        />
      )}
    </Popup>
  );
};
export default AddPayment;
